'use strict';

exports.__esModule = true;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _mozart_ui = require('@pgforsta/mozart_ui');

var _reactBootstrap = require('react-bootstrap');

var _Unsubscription = require('redux/modules/Unsubscription');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Unsubscription = function (_Component) {
  (0, _inherits3.default)(Unsubscription, _Component);

  function Unsubscription(props) {
    (0, _classCallCheck3.default)(this, Unsubscription);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.state = {
      validate: true,
      identifierValue: '',
      identifier: '',
      show: false,
      action: '',
      response: 'failed'
    };
    _this.clientId = _this.props.params && _this.props.params.clientId ? _this.props.params.clientId : 'undefined';
    _this.phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    _this.emailRegex = /^(([^<>()[\]\\,;:\s@"]+(\.[^<>()[\]\\,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z0-9.-]+\.)+[a-zA-Z]{2,20}))$/;
    return _this;
  }

  Unsubscription.prototype.isValidate = function isValidate(data) {
    if (this.emailRegex.test(data) || this.phoneRegex.test(data)) {
      this.setState({
        validate: false,
        identifierValue: data.trim(),
        identifier: this.emailRegex.test(data) ? 'email' : 'phone'
      });
    } else {
      this.setState({
        validate: true,
        identifierValue: data
      });
    }
  };

  Unsubscription.prototype.handleSubmit = function handleSubmit() {
    var _this2 = this;

    this.setState({
      validate: this.state.response === 'unauthorised' ? this.state.validate : true,
      identifierValue: this.state.response === 'unauthorised' ? this.state.identifierValue : '',
      identifier: this.state.response === 'unauthorised' ? this.state.identifier : '',
      show: false,
      response: this.state.response === 'unauthorised' ? this.state.response : 'failed'
    }, function () {
      if (_this2.state.response !== 'unauthorised') {
        document.getElementById('textbox').value = '';
      }
    });
  };

  Unsubscription.prototype.showHide = function showHide() {
    this.setState({ show: true });
  };

  Unsubscription.prototype.handleSubscription = function handleSubscription(action) {
    var _this3 = this;

    this.setState({
      action: action
    }, function () {
      var data = {
        identifierValue: _this3.state.identifierValue,
        action: _this3.state.action,
        clientId: _this3.clientId,
        identifier: _this3.state.identifier
      };
      _this3.props.loadUnsubscription(data).then(function (response) {
        if (response) {
          _this3.setState({
            response: 'success'
          });
        }
        _this3.showHide();
      }).catch(function (response) {
        if (response && response.status === 401) {
          _this3.setState({
            response: 'unauthorised'
          });
        }
        _this3.showHide();
      });
    });
  };

  Unsubscription.prototype.snackbarMessage = function snackbarMessage() {
    var snackbarMessage = this.state.action + 'd Successfully.';
    var message = '';
    if (this.state.response === 'success') {
      message = snackbarMessage.toUpperCase();
    } else if (this.state.response === 'unauthorised') {
      message = 'NO ACCESS. PLEASE LOGIN TO CONTINUE.';
    } else {
      message = 'SOMETHING WENT WRONG';
    }
    return message;
  };

  Unsubscription.prototype.render = function render() {
    var _this4 = this;

    var styles = require('./Unsubscription.scss');
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_reactHelmet2.default, { title: 'Subscribe / Unsubscribe' }),
      _react2.default.createElement(
        _reactBootstrap.Row,
        null,
        _react2.default.createElement(
          _reactBootstrap.Col,
          { xs: 12, md: 12 },
          _react2.default.createElement(
            'div',
            { className: styles.header },
            'Subscribe / Unsubscribe'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.unsubscription_container },
            _react2.default.createElement(
              'div',
              { className: styles.email_phone_textbox },
              _react2.default.createElement(
                'div',
                { className: styles.email_phone_text },
                'Enter Email/Phone :'
              ),
              _react2.default.createElement(
                'div',
                { className: styles.email_phone_box },
                _react2.default.createElement(_mozart_ui.MozartTextBox, {
                  key: 'text',
                  id: 'textbox',
                  className: 'textbox',
                  name: 'text',
                  errorFontSize: '11px',
                  hintText: 'Enter an Email or a Phone',
                  onChange: this.isValidate.bind(this),
                  validationBool: false,
                  style: {
                    // width: '388px'
                  }
                }),
                this.state.validate && (this.state.identifierValue !== '' ? _react2.default.createElement(
                  'div',
                  { className: styles.label },
                  'Please enter a valid text'
                ) : _react2.default.createElement(
                  'div',
                  { className: styles.label },
                  'Please enter a value for text'
                ))
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.submit },
              _react2.default.createElement(_mozart_ui.MozartButton, {
                className: 'subscribe',
                data: 'Subscribe',
                id: 'subscribe',
                disabled: this.state.validate,
                onClick: this.handleSubscription.bind(this, 'subscribe'),
                style: {
                  width: '150px',
                  marginLeft: '168px'
                }
              }),
              _react2.default.createElement(_mozart_ui.MozartButton, {
                className: 'unsubscribe',
                data: 'Unsubscribe',
                id: 'unsubscribe',
                disabled: this.state.validate,
                onClick: this.handleSubscription.bind(this, 'unsubscribe'),
                style: {
                  width: '150px',
                  marginLeft: '84px'
                }
              })
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_mozart_ui.MozartSnackBar, {
                autoHideDuration: '2600',
                message: this.snackbarMessage(),
                onRequestClose: function onRequestClose() {
                  _this4.handleSubmit();
                },
                open: this.state.show
              })
            )
          )
        )
      )
    );
  };

  return Unsubscription;
}(_react.Component);

Unsubscription.propTypes = {
  loadUnsubscription: _propTypes2.default.func,
  params: _propTypes2.default.object
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    loadUnsubscription: _Unsubscription.loadUnsubscription
  }, dispatch);
};

var mapStateToProps = function mapStateToProps() {
  return {};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Unsubscription);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Unsubscription/Unsubscription.js
// module id = 2355
// module chunks = 0